<template>
  <div class="row sqs-row">
    <div class="col sqs-col-12 span-12">
      <div class="sqs-block html-block sqs-block-html">
        <div class="sqs-block-content">
          <h1>Please Update Your Account</h1>
          <p>
            <strong>Welcome back<span v-if="user"> {{user.username}}</span>!</strong>
          </p>
          <p>
            This year we are hoping to gather more information about the good folks (like yourself!) who enjoy counting fish as much as we do.
          </p>
          <p>
            The following information will only be accessible to MyRWA staff and used for maintaining contact lists. We will never share your information or email address with any outside organization.
          </p>
          <p>
            If you have a minute, would you mind filling out the following form to update your account? Thanks so much!
          </p>
        </div>
      </div>
      <div class="sqs-block form-block sqs-block-form">
        <div class="sqs-block-content">
          <div class="form-wrapper">
            <div class="form-inner-wrapper">
              <form v-on:submit.prevent="updateInfo" @submit="$v.$touch()">
                <div class="field-list clear">
                  <fieldset class="form-item fields name">
                    <legend class="title">Name (optional)</legend>
                    <div class="field first-name">
                      <label class="caption">
                        <input class="field-element field-control" name="fname" x-autocompletetype="given-name" type="text" spellcheck="false" maxlength="30" data-title="First" v-model="firstName">
                        <span class="caption-text">First Name</span>
                      </label>
                    </div>
                    <div class="field last-name">
                      <label class="caption">
                        <input class="field-element field-control" name="lname" x-autocompletetype="surname" type="text" spellcheck="false" maxlength="30" data-title="Last" v-model="lastName">
                        <span class="caption-text">Last Name</span>
                      </label>
                    </div>
                  </fieldset>
                  <div class="form-item field text">
                    <label class="title" for="text-zip-field">
                      Zip Code (optional)
                    </label>
                    <input class="field-element text" type="text" id="text-zip-field" v-model="zip">
                  </div>
                  <fieldset class="form-item field checkbox">
                    <legend class="title">
                      Communication Preferences
                    </legend>
                    <div class="option">
                      <label>
                        <input type="checkbox" name="checkbox-allow-email-field" v-model="allowEmail">
                        Yes, I opt-in to receive emails from MyRWA
                      </label>
                    </div>
                  </fieldset>
                </div>
                <div class="sqs-block button-block sqs-block-button">
                  <div class="sqs-block-content">
                    <div class="sqs-block-button-container--center">
                      <a
                        href=""
                        class="sqs-block-button-element--medium sqs-block-button-element"
                        :class="{ disabled: infoForm.submitted || infoForm.done }"
                        style="margin-right:50px"
                        @click.prevent="updateInfo">
                        Submit
                      </a>
                      <a
                        href=""
                        class="sqs-block-button-element--medium sqs-block-button-element"
                        :class="{ disabled: infoForm.submitted || infoForm.done }"
                        style="margin-left:50px"
                        @click.prevent="skip">
                        No Thanks!
                      </a>
                    </div>
                  </div>
                </div>
              </form>
              <p v-if="error" class="is-danger">{{ error }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'signup',
  data () {
    return {
      firstName: null,
      lastName: null,
      zip: null,
      allowEmail: true,
      error: null,
      submitted: false,
      loading: false,
      infoForm: {
        message: null,
        error: null,
        submitted: false,
        done: false
      }
    }
  },
  validations: {
    firstName: {
      maxLength: maxLength(250)
    },
    lastName: {
      maxLength: maxLength(250)
    },
    zip: {
      maxLength: maxLength(10)
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  mounted () {
    if (!this.user) return

    this.firstName = this.user.first_name
    this.lastName = this.user.last_name
    this.zip = this.user.zip
    this.allowEmail = this.user.allow_email
  },
  methods: {
    updateInfo () {
      if (this.infoForm.submitted) return

      this.infoForm.submitted = true
      this.infoForm.message = null
      this.infoForm.error = null

      if (!this.$v.firstName.$invalid && !this.$v.lastName.$invalid && !this.$v.zip.$invalid) {
        const payload = {
          first_name: this.firstName,
          last_name: this.lastName,
          zip: this.zip,
          allow_email: this.allowEmail,
          updated: true
        }
        this.$auth.updateAttributes(payload)
          .then(() => {
            this.infoForm.message = 'Thanks! Your information has been updated'
            this.infoForm.submitted = false
            this.infoForm.done = true
            setTimeout(() => {
              this.$router.push('/')
            }, 3000)
          })
          .catch((err) => {
            this.infoForm.error = err.message || 'Unknown error occurred.'
            this.infoForm.submitted = false
            console.log(err)
          })
      }
    },
    skip () {
      this.infoForm.submitted = true
      this.infoForm.message = null
      this.infoForm.error = null
      const payload = {
        updated: true
      }
      this.$auth.updateAttributes(payload)
        .then(() => {
          this.infoForm.submitted = false
          this.$router.push('/')
        })
        .catch((err) => {
          this.infoForm.submitted = false
          this.infoForm.error = err.message || 'Unknown error occurred.'
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
.description {
  white-space: normal !important;
}
.sqs-block-button-element--medium.sqs-block-button-element.disabled {
  background-color: #aaa !important;
  cursor: default;
}

</style>
